import { render, staticRenderFns } from "./SmartFacility.vue?vue&type=template&id=87f04f4a&scoped=true&"
import script from "./SmartFacility.vue?vue&type=script&lang=js&"
export * from "./SmartFacility.vue?vue&type=script&lang=js&"
import style0 from "./SmartFacility.vue?vue&type=style&index=0&id=87f04f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f04f4a",
  null
  
)

export default component.exports